import { api } from './api';
import type { CostsOverview, FixedCost } from '../types';

export const costsApi = {
  get: (days = 30) => api.get<CostsOverview>(`/stats/costs?days=${days}`),
  createFixed: (data: Partial<FixedCost>) => api.post<FixedCost>('/stats/costs/fixed', data),
  updateFixed: (id: number, data: Partial<FixedCost>) =>
    api.patch<FixedCost>(`/stats/costs/fixed/${id}`, data),
  removeFixed: (id: number) => api.delete<{ ok: boolean }>(`/stats/costs/fixed/${id}`),
};
